import { render, staticRenderFns } from "./sale-by-serial.vue?vue&type=template&id=1c0965cb&scoped=true&"
import script from "./sale-by-serial.vue?vue&type=script&lang=js&"
export * from "./sale-by-serial.vue?vue&type=script&lang=js&"
import style0 from "./sale-by-serial.vue?vue&type=style&index=0&id=1c0965cb&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c0965cb",
  null
  
)

export default component.exports